<div
  role="group"
  attr.aria-labelledby="filterTitle-{{ filterName }}"
  class="search-filter-range-sidebar"
>
  <!-- Range Filter, eg Price Range -->
  <button
    type="button"
    attr.aria-expanded="{{ isExpanded }}"
    id="filterTitle-{{ filterName }}"
    class="filter--title"
    (click)="toggleFilterOptions()"
    attr.data-dgat="search-filter-range-sidebar-{{ filterName }}"
  >
    <div class="l_flexbar l_flex-justify l_flex-middle">
      <div class="l_flex l_flex-middle">
        <div class="h4">
          {{ 'Core_' + filterName | translate }}
          <div
            *ngIf="selectedOptionCount > 0"
            class="
              badge badge-pill badge-pill--compact
              badge-emphasize
              guts-m-l-half
            "
          >
            {{ selectedOptionCount }}
          </div>
        </div>
      </div>

      <!-- Icon -->
      <df-icon
        class="filter--title-icon"
        size="medium"
        [icon]="isExpanded ? 'chevron-up' : 'chevron-down'"
      ></df-icon>
    </div>
  </button>

  <!-- Filter Options -->
  <div *ngIf="isExpanded" class="guts-p-l-1">
    <dgx-search-filter-sidebar-range-options
      [filter]="filter"
      (filtersChanged)="filtersChanged.emit($event)"
    ></dgx-search-filter-sidebar-range-options>
  </div>
</div>
